/** Colunas do order by da consulta da Análise de Mercado RAP */
export enum ClienteAnaliseMercadoRAPOrderByColumn {
    CODIGO_INTEGRACAO_ERP_CLIENTE = 1,
    NOME_CLIENTE = 2,
    NOME_REPRESENTANTE = 3,

    VALOR_POTENCIAL_ANO_ANTERIOR1 = 4,
    VALOR_POTENCIAL = 5,

    VALOR_PRETENDIDO_ANO_ANTERIOR1 = 6,
    VALOR_PRETENDIDO = 7,
    CUSTOMER_SHARE_RAP = 8,
    CLASSIFICACAO_RAP = 9,

    VALOR_PROJETADO_ANO_ANTERIOR1 = 10,
    VALOR_PROJETADO = 11,
    CUSTOMER_SHARE_RAP_PROJETADO = 12,

    VALOR_REALIZADO_ANO_ANTERIOR2 = 13,
    VALOR_REALIZADO_ANO_ANTERIOR1 = 14,
    VALOR_REALIZADO = 15,
    CUSTOMER_SHARE_RAR = 16,
    CLASSIFICACAO_RAR = 17
};

/** Order By da consulta da Análise de Mercado RAP */
export interface ClienteAnaliseMercadoRAPOrderBy {
    column: ClienteAnaliseMercadoRAPOrderByColumn;
    dir: string;
}
